module.exports = __webpack_public_path__ + "static/media/overlay-purple.ed3309f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tags/overlay-purple.svg
// module id = 565
// module chunks = 0